import { Button } from '@mui/material';
import { styled } from '@mui/material/styles';
import { Paper, Box, Typography } from '@mui/material';
import PropTypes from 'prop-types';

export const STPButton = styled(Button)({
  backgroundColor: '#50A579',
  borderRadius: '100px',
  width: '150px',
  height: '40px',
  color: 'white',
  '&:hover': {
    backgroundColor: '#50A579',
  },
});

const UnreadIndicator = styled('span')(({ theme }) => ({
  position: 'absolute',
  top: theme.spacing(-1),
  right: theme.spacing(-1),
  width: 25,
  height: 25,
  borderRadius: '50%',
  backgroundColor: "#c40e0e",
  color: 'white',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  fontSize: '15px',
  fontWeight: 'bold',
}));


export const MenuButton = ({ icon, label, unReadNotifications, disabled }) => (

  <Paper
    elevation={3}
    sx={{
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      backgroundColor: 'white',
      height: '17vh',
      cursor: disabled ? 'not-allowed' : 'pointer',
      position: 'relative',
      textAlign: 'center',
      opacity: disabled ? 0.5 : 1,
      pointerEvents: disabled ? 'none' : 'auto',
    }}
  >
    {(label === 'Onlive') ? icon 
    : <>
        <Box
          sx={{
            backgroundColor: '#50A579',
            borderRadius: '50%',
            width: '65px',
            height: '65px',
            padding: 2,
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          {icon}
          {unReadNotifications ? <UnreadIndicator>{unReadNotifications}</UnreadIndicator> : null}
        </Box>
        <Typography variant="subtitle1" sx={{ padding: 1 }}>{label}</Typography>
      </>
    }
  </Paper>
);

MenuButton.propTypes = {
  icon: PropTypes.node.isRequired,
  label: PropTypes.string.isRequired,
  unReadNotifications: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number
  ]),
  disabled: PropTypes.bool
};